import {Component, Input} from '@angular/core';
import {Label} from '../../../model/Label';


@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    imports: [],
    styleUrls: ['./badge.component.css']
})
export class BadgeComponent {

  @Input()
  label: Label;

}
